import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/honk-light/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/honk-light/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/honk-light/locales/fi/messages.mjs';
import { messages as daMessages} from '../src/raw/honk-light/locales/da/messages.mjs';
import { messages as svMessages} from '../src/raw/honk-light/locales/sv/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages, daMessages, svMessages);


export class IconHonkLight42 extends LitElement {
  render() {
      const title = i18n.t({ message: `Honk`, id: 'icon.title.honklight', comment: 'Title for HonkLight icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28" part="w-icon-honk-light-42-part">${unsafeStatic(`<title>${title}</title>`)}<path fill="#570E2D" d="M27.34 2a5.66 5.66 0 1 0 0 11.32 5.66 5.66 0 0 0 0-11.32m0 8.572a2.912 2.912 0 1 1 0-5.823 2.912 2.912 0 0 1 0 5.823m-9.768 4.108v7.33l-5.049-7.33H9V26h2.749v-8.454L17.572 26h2.749V14.68zM29.799 26H33l-4.576-6.553 4.264-4.768H29.58l-5.152 5.991v-5.99H21.68V26h2.75v-2.084l2.197-2.458L29.798 26ZM17.572 2v4.436h-5.823V2H9v11.32h2.749V8.885h5.823v4.437h2.749V2z"></path></svg>`; }
}
if (!customElements.get('w-icon-honk-light-42')) {
  customElements.define('w-icon-honk-light-42', IconHonkLight42);
}